import { Card } from "./Card";
import { formatOffset } from "../flasher/chips";
import { formatBytes, type PartitionEntry } from "../flasher/binaryInfo";

interface Props {
  partitions: PartitionEntry[];
  sourceFileName: string;
}

/**
 * Renders the partition table found in the uploaded table image. Mostly a
 * confidence signal: seeing the real layout, with the app slot sized as
 * expected, tells a user their partition scheme is what they think it is.
 */
export function PartitionTablePanel({ partitions, sourceFileName }: Props) {
  return (
    <Card title="Partition table" hint={`Read from ${sourceFileName}`}>
      <div className="table-scroll">
        <table className="ptable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Subtype</th>
              <th>Offset</th>
              <th>Size</th>
            </tr>
          </thead>
          <tbody>
            {partitions.map((partition) => (
              <tr key={`${partition.label}-${partition.offset}`}>
                <td>{partition.label}</td>
                <td>{partition.typeName}</td>
                <td>{partition.subTypeName}</td>
                <td>{formatOffset(partition.offset)}</td>
                <td>{formatBytes(partition.size)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="muted">
        Your application is written to the first <code>app</code> partition. If a sketch is too large for that slot,
        choose a different partition scheme in the Arduino IDE under <strong>Tools &rsaquo; Partition Scheme</strong>.
      </p>
    </Card>
  );
}
